import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { KeyboardArrowDown } from '@mui/icons-material';
import clsx from 'clsx';
import DashboardCard from './DashboardCard';
import SubCategoryPill from './SubCategoryPill';

const CategorySection = ({ category, onToggleFavorite, onViewAccess, icons }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeSubCategory, setActiveSubCategory] = useState(
        Object.keys(category.subcategories)[0]
    );

    const displayedDashboards = category.subcategories[activeSubCategory]?.dashboards || [];
    const CategoryIcon = icons.category[category.name?.toUpperCase()] || icons.category["ADMINISTRAÇÃO"];

    return (
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 transition-all">
            <div
                className="flex items-center justify-between p-6 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex items-center gap-4">
                    {CategoryIcon && <CategoryIcon className="text-gray-500 dark:text-gray-400" />}
                    <span className="text-xl font-bold text-gray-800 dark:text-gray-100">
                        {category.name}
                    </span>
                </div>
                <KeyboardArrowDown
                    className={clsx(
                        'text-gray-500 transition-transform duration-300',
                        isOpen && 'rotate-180'
                    )}
                />
            </div>

            <div
                className={clsx(
                    'transition-all duration-500 ease-in-out grid',
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                )}
            >
                <div className="overflow-hidden">
                    <div className="p-6 border-t border-gray-200 dark:border-gray-700">
                        <div className="flex flex-wrap gap-3 mb-6">
                            {Object.entries(category.subcategories).map(([subCatName, subCatData]) => (
                                <SubCategoryPill
                                    key={subCatName}
                                    name={subCatName}
                                    icon={icons.subcategory[subCatName?.toUpperCase()]}
                                    isActive={activeSubCategory === subCatName}
                                    onClick={() => setActiveSubCategory(subCatName)}
                                    groupId={subCatData.id}
                                    onViewAccess={onViewAccess}
                                />
                            ))}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">
                            {displayedDashboards.map((dashboard) => (
                                <DashboardCard
                                    key={dashboard.id}
                                    dashboard={dashboard}
                                    onToggleFavorite={onToggleFavorite}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

CategorySection.propTypes = {
    category: PropTypes.shape({
        name: PropTypes.string.isRequired,
        subcategories: PropTypes.object.isRequired,
    }).isRequired,
    onToggleFavorite: PropTypes.func.isRequired,
    onViewAccess: PropTypes.func.isRequired,
    icons: PropTypes.shape({
        category: PropTypes.object.isRequired,
        subcategory: PropTypes.object.isRequired,
    }).isRequired,
};

export default React.memo(CategorySection);
